import { jsPDF } from "jspdf";
import { PROJECT_NAME } from "./constants";

/**
 * Utility to export research items to PDF.
 * Extracted from MainPage.js for modularity.
 */
export const exportToPDF = (item) => {
    const doc = new jsPDF();
    const isLegacyContent = typeof item.content === 'string';
    const content = isLegacyContent ? {} : item.content;

    let y = 20;
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);

    // Helper for adding text with auto-wrapping
    const addWrappedText = (text, fontSize = 12, fontStyle = 'normal') => {
        if (!text) return;
        doc.setFontSize(fontSize);
        doc.setFont(undefined, fontStyle);
        const lines = doc.splitTextToSize(text, contentWidth);

        if (y + (lines.length * (fontSize / 2)) > 280) {
            doc.addPage();
            y = 20;
        }

        doc.text(lines, margin, y);
        y += (lines.length * (fontSize / 2)) + 5;
    };

    // Header
    doc.setFillColor(15, 23, 42); // slate-900
    doc.rect(0, 0, pageWidth, 40, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(22);
    doc.setFont(undefined, 'bold');
    doc.text(PROJECT_NAME, margin, 25);

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text("AI-Powered Research Assistant", margin, 32);

    doc.text(new Date().toLocaleDateString(), pageWidth - margin - 20, 25);
    y = 55;

    // Title
    doc.setTextColor(15, 23, 42);
    addWrappedText(item.title, 18, 'bold');

    doc.setFontSize(10);
    doc.setTextColor(107, 114, 128);
    doc.text(`Type: ${item.type === 'analysis' ? 'Single Analysis' : 'Paper Comparison'}`, margin, y);
    y += 15;

    // Executive Summary
    doc.setTextColor(15, 23, 42);
    addWrappedText("Executive Summary", 14, 'bold');
    addWrappedText(isLegacyContent ? item.content : content.summary, 11);
    y += 5;

    if (!isLegacyContent) {
        if (item.type === 'analysis') {
            if (content.keyFindings?.length > 0) {
                addWrappedText("Key Findings", 14, 'bold');
                content.keyFindings.forEach((f, i) => {
                    addWrappedText(`${i + 1}. ${f}`, 11);
                });
                y += 5;
            }

            if (content.methodology) {
                addWrappedText("Methodology", 14, 'bold');
                addWrappedText(content.methodology, 11);
                y += 5;
            }

            if (content.conclusion) {
                addWrappedText("Conclusion", 14, 'bold');
                addWrappedText(content.conclusion, 11);
                y += 5;
            }
        } else if (item.type === 'comparison') {
            addWrappedText("Comparison Analysis", 14, 'bold');
            content.comparisonPoints?.forEach(point => {
                doc.setFontSize(11);
                doc.setFont(undefined, 'bold');
                doc.text(`${point.feature}:`, margin, y);
                y += 6;
                doc.setFont(undefined, 'normal');
                addWrappedText(`Paper 1: ${point.paper1}`, 10);
                addWrappedText(`Paper 2: ${point.paper2}`, 10);
                y += 3;
            });
        }
    }

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text(`Page ${i} of ${pageCount} - Generated by ${PROJECT_NAME}`, pageWidth / 2, 290, { align: 'center' });
    }

    doc.save(`${item.title.replace(/\s+/g, '_')}_Analysis.pdf`);
};
